import _toConsumableArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { combine } from '@datadog/browser-core';
export function createHooks() {
  var callbacks = {};
  return {
    register: function register(hookName, callback) {
      if (!callbacks[hookName]) {
        callbacks[hookName] = [];
      }
      callbacks[hookName].push(callback);
      return {
        unregister: function unregister() {
          callbacks[hookName] = callbacks[hookName].filter(function (cb) {
            return cb !== callback;
          });
        }
      };
    },
    triggerHook: function triggerHook(hookName, param) {
      var hookCallbacks = callbacks[hookName] || [];
      var results = hookCallbacks.map(function (callback) {
        return callback(param);
      });
      return combine.apply(void 0, _toConsumableArray(results));
    }
  };
}